import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'

export const IconUserChanged = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 24 24" sx={{ fill: 'none', ...props.sx }}>
    <circle
      cx="4"
      cy="4"
      r="4"
      transform="matrix(-1 0 0 1 13 3)"
      stroke="#FFAB00"
      strokeWidth="1.5"
    />
    <path
      d="M2 16.9347C2 16.0743 2.54085 15.3068 3.35109 15.0175V15.0175C7.00404 13.7128 10.996 13.7128 14.6489 15.0175V15.0175C15.4591 15.3068 16 16.0743 16 16.9347V18.2502C16 19.4376 14.9483 20.3498 13.7728 20.1818L12.8184 20.0455C10.2856 19.6837 7.71435 19.6837 5.18162 20.0455L4.22721 20.1818C3.0517 20.3498 2 19.4376 2 18.2502V16.9347Z"
      stroke="#FFAB00"
      strokeWidth="1.5"
    />
    <path
      d="M16.0022 10.2099C16.0022 10.2099 16.6352 9.34749 17.1494 8.8329C17.6636 8.31831 18.3743 8 19.1592 8C20.7285 8 22.0006 9.27211 22.0006 10.8413C22.0006 12.4106 20.7285 13.6827 19.1592 13.6827C18.1741 13.6827 17.3061 13.1813 16.7964 12.4198M16.0022 10.2099V8.3157M16.0022 10.2099H17.8964"
      stroke="#FFAB00"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
)
